import React from 'react';
import AppModal from "../../core/components/app-modal";
import {ModalIds} from "@common/models/enums/modal-ids.enum";
import useModalWithData from "@common/hooks/use-modal-with-data";
import AppButton from "@common/components/app-button";
import {animated} from "@react-spring/web";
import {useModalAnimation} from "../../core/animations";

const UniversalArticleDeleteInfoModal: React.FC = () => {
    const {hideModal, isOpenModal} = useModalWithData<void>(ModalIds.ARTICLE_DELETE_BLOCKED_UNIVERSAL);
    const {springProps, closeModal} = useModalAnimation(!!isOpenModal(), 'medium');

    const handleClose = (): void => {
        closeModal( () => hideModal());
    };

    return (
        <AppModal
            id={ModalIds.ARTICLE_DELETE_BLOCKED_UNIVERSAL}
            key={ModalIds.ARTICLE_DELETE_BLOCKED_UNIVERSAL}
            zIndex={50}
            forceFixed={true}
            classModal="flex justify-center"
        >
            <animated.div
                style={springProps}
                className="h-full w-full flex flex-col bg-[#F9FAFB] rounded-2xl md:min-w-[560px] md:max-w-[640px] max-h-[280px] "
            >
                <div className="flex items-center justify-between pl-8 pr-4 py-3 h-[72px] max-h-[72px]">
                    <h2 className="text-lg font-semibold text-on-surface leading-[22px]">Nie można usunąć artykułu</h2>
                </div>
                <div className="px-8 py-4 text-on-surface/90">
                    Ten artykuł jest oznaczony jako <span className="font-semibold">uniwersalny</span> i nie może zostać usunięty.
                </div>
                <div className="flex items-center gap-3 justify-end px-8 h-[72px] max-h-[72px]">
                    <AppButton
                        onClick={handleClose}
                        className="bg-primary max-h-[40px] h-[40px] !px-6 !pt-2 text-on-primary font-semibold text-base !rounded-full hover:bg-primary/80"
                        label="Rozumiem"
                    />
                </div>
            </animated.div>
        </AppModal>
    );
};

export default UniversalArticleDeleteInfoModal;


